import { h, FunctionalComponent } from 'preact';
import styles from './style.css';
import { get_APP_URI_BASE } from '../../configs/env';
import { useAppSelector } from '../../redux/hooks';

export interface PrerequisitesBoxProps {
    workspaceAlias?: string; 
    portalAlias ?: string;
    prerequisitesConditions: string[];
    prerequisitesQueries: string[];
}

const PrerequisitesBox: FunctionalComponent<PrerequisitesBoxProps> = ({ prerequisitesConditions,prerequisitesQueries,workspaceAlias,portalAlias}) => {
    const alias = useAppSelector((state) => state.alias);
    
    return (
        <div className={styles.staticBox}>
            <div className={styles.conditionsBox}>
            <h4>Prerequisites Conditions</h4>
            <ul>
                {prerequisitesConditions.map((condition, index) => (
                    <li key={`prerequisite-conditions-${index}`}>
                                {condition}
                    </li>
                ))}
            </ul>
            </div>
            <div className={styles.queriesBox}>
            <h4>Related Queries</h4>
            <ul>
                {prerequisitesQueries.map((question, index) => (
                    <li key={`prerequisite-${index}`}>
                        <a href={`${get_APP_URI_BASE()}/${alias.workspaceAlias}/${alias.portalAlias}/search?q=${question}`} target="_blank" rel="noopener noreferrer">
                            {question}
                        </a>
                    </li>
                ))}
            </ul>
            </div>
        </div>
    );
};

export default PrerequisitesBox;
